var _rect, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmptyPhoto(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 99,
    height: 99,
    rx: 7.5,
    fill: "white",
    stroke: "#858B8A",
    strokeDasharray: "5 5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M49.0833 57.5H44.6667C44.2246 57.5 43.8007 57.3244 43.4882 57.0118C43.1756 56.6993 43 56.2754 43 55.8333V44.1667C43 43.7246 43.1756 43.3007 43.4882 42.9882C43.8007 42.6756 44.2246 42.5 44.6667 42.5H56.3333C56.7754 42.5 57.1993 42.6756 57.5118 42.9882C57.8244 43.3007 58 43.7246 58 44.1667V52.5L55.4167 49.9167C55.1031 49.6093 54.6809 49.4381 54.2418 49.4403C53.8027 49.4425 53.3822 49.6179 53.0717 49.9283L45.5 57.5",
    stroke: "#171818",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M52.1667 56.25L54.6667 53.75L57.1667 56.25",
    stroke: "#171818",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M54.6667 58.3333V53.75",
    stroke: "#171818",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M48 49.1666C48.9205 49.1666 49.6666 48.4204 49.6666 47.4999C49.6666 46.5794 48.9205 45.8333 48 45.8333C47.0795 45.8333 46.3333 46.5794 46.3333 47.4999C46.3333 48.4204 47.0795 49.1666 48 49.1666Z",
    stroke: "#171818",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyPhoto);
export default __webpack_public_path__ + "static/media/emptyPhoto.b23d063d481fb39fc58d3ecb3740595d.svg";
export { ForwardRef as ReactComponent };